export class StudentsInClass {
    id: number;
    aisId: string;
    familyName: string;
    givenName: string;
    dateOfBirth: string;
    gender: string;
    country: string;
    homeroom: Homeroom;
}
class Homeroom {
    id: number;
    name: string;
    campusId: number;
    yearLevelId: number;
}


// WEBPACK FOOTER //
// ./src/holiday/models/StudentsInClass.ts